
<template>
  <div class="musicwow">
    <Headers></Headers>
    <div class="musicwow-center">
      <!-- <img src="https://aliyunosszs.musicwow.com/APPimg/product/product(5).png"> -->
      <img :src="bgUrl" />
      <div class="center-body">
        <!-- //超级网络课 -->
        <div>
          <h3>超级网络课</h3>
          <div class="list-show"></div>
          <ul class="oneList">
            <li v-for="(item, idx) in navData" :key="idx">
              <img :src="item.cover" />
              <div class="oneList-items">
                <div class="items-text">
                  <p>{{ item.title }}</p>
                  <p>{{ item.describe }}</p>
                </div>
                <div class="items-mor">
                  <div class="mor-mon">
                    <span class="mon-text">￥</span>
                    <span class="mon-num">{{ item.money }}元</span>
                  </div>
                  <div class="mor-det" @click="onSuperData(item.id)">
                    <span>课程详情</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="oneList-mor" @click="onSuperMor()">查看更多</div>
        </div>
        <!-- 品牌音乐 -->
        <div class="body-items">
          <h3>品牌音乐</h3>
          <div class="list-show"></div>
          <ul class="musicList">
            <li v-for="(item, idx) in listData" :key="idx">
              <div class="musicList-left">
                <img :src="item.cover" />
              </div>
              <div class="musicList-items">
                <p class="items-title">{{ item.title }}</p>
                <p class="items-show">产品描述：</p>
                <div class="items-text">
                  {{ item.describe }}
                </div>
                <div class="items-mor" @click="onMusicData(item.id)">
                  了解详情 >
                </div>
              </div>
            </li>
          </ul>
          <div class="musicList-mor" @click="onMusicMor()">查看更多</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "musicwow",
  data() {
    return {
      navData: [],
      listData: [],
      bgUrl: "",
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {
    onMusicData(id) {
      // console.log(id)
      localStorage.detailsId = id || localStorage.detailsId;
      this.$router.push({ name: "MusicwowDetails", params: { id: id } });
    },
    onSuperData(id) {
      // console.log(id)
      localStorage.detailsId = id || localStorage.detailsId;
      this.$router.push({ name: "SuperBook", params: { id: id } });
    },
    onSuperMor() {
      this.$router.push({ name: "SuperMor" });
    },
    onMusicMor() {
      this.$router.push({ name: "MusicMor" });
    },
    async onBulist() {
      let bgData = await this.$API.getBgListData({});
      let listData = bgData.data;
      listData.forEach((item, index) => {
        switch (item.type) {
          case "mobile_music":
            this.bgUrl = item.image;
            // console.log(item)
            break;
        }
      });
    },
    async onProductData() {
      let productData = await this.$API.getProductData({ type_id: 1 });
      let a = productData.data;
      for (let i in a) {
        if (i < 4) {
          this.listData.push(a[i]);
        }
      }
    },
    async onSuperListData() {
      let productData = await this.$API.getProductData({ type_id: 2 });
      let a = productData.data;
      for (let i in a) {
        if (i < 4) {
          this.navData.push(a[i]);
        }
      }
    },
  },
  mounted() {
    this.onBulist();
    this.onProductData();
    this.onSuperListData();
  },
  async created() {},
};
</script>
<style lang="sass" scoped>
.musicwow
  .musicwow-center
    padding-top: 60px
    img
      width: 100%
    .center-body
      margin: 20px 0
      h3
        font-size: 24px
      .body-text
        font-size: 12px
        color: #9E9E9E
        margin: auto
        margin-top: 8px
        text-align: center
      .list-show
        width: 44px
        height: 5px
        background: #07D1AA
        margin: 20px auto
      .oneList
        margin: 20px
        li
          padding: 12px 0

          .oneList-items
            padding: 10px
            box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.1)
            border-radius: 0px 0 4px 4px

            .items-text
              text-align: left
              padding-bottom: 30px
              padding-top: 10px
            .items-text>p:nth-child(1)
              font-size: 14px
              color: #1E1E1E
            .items-text>p:nth-child(2)
              font-size: 11px
              color: #979797
            .items-mor
              display: flex
              padding: 15px 0
              border-top: 1px solid #EDEDED

              .mor-mon
                color: #979797
                .mon-text
                  font-size: 10px
                .mon-num
                  font-size: 20px
              .mor-det
                height: 26px
                width: 60px
                margin-left: auto
                border-radius: 4px
                color: #fff
                line-height: 26px
                font-size: 10px
                background: linear-gradient(137deg,rgba(32,210,200,1) 0%,rgba(7,209,170,1) 100%)
                // padding: 5px
      .oneList-mor
        width: 91px
        height: 31px
        border: 1px solid #07D1AA
        color: #07D1AA
        border-radius: 20px
        margin: auto
        line-height: 31px
        font-size: 14px
        margin-top: 10px
  .body-items
    margin: 35px
    padding-top: 20px
    .musicList
      li
        display: flex
        padding: 20px 0
        align-items: center
        .musicList-left
          flex: 6
          text-align: left
          img
            width: 115px !important
        .musicList-items
          flex: 6
          text-align: left
          // margin: 40px 0
          margin-left: auto
          .items-title
            font-size: 20px
          .items-show
            font-size: 12px
            color: #000000
            margin-top: 10px
            line-height: 20px
          .items-text
            color: #9E9E9E
            max-width: 131px
            line-height: 20px
          .items-mor
            border-radius: 18px
            border: 1px solid #979797
            width: 69px
            padding: 5px 0
            text-align: center
            font-size: 10px
            color: #5C5C5C
            margin-top: 35px
    .musicList-mor
      width: 91px
      height: 31px
      border: 1px solid #07D1AA
      color: #07D1AA
      border-radius: 20px
      margin: auto
      line-height: 31px
      font-size: 14px
      margin-top: 50px
</style>

